export function hero() {

  const goToSlide = (target_idx) => {
    document.querySelector('.slide.active').classList.remove('active');
    document.querySelector('.slider-link.active').classList.remove('active');
    document.querySelector('.slide[data-idx="'+target_idx+'"]').classList.add('active');
    document.querySelector('.slider-link[data-id="'+target_idx+'"]').classList.add('active');
  }

  const runSlider = () => {
    const current_idx = parseInt(document.querySelector('.slide.active').dataset.idx);
    const next_idx = document.querySelector('.slide[data-idx="'+parseInt(current_idx+1)+'"]') ? current_idx + 1 : 1;
    goToSlide(next_idx);
  }

  const sliderLinkHandler = (runningSlider, e) => {
    clearInterval(runningSlider);
    const target_idx = e.currentTarget.dataset.id;
    goToSlide(target_idx);
  }

  document.addEventListener( 'DOMContentLoaded', function() {

    const transitionSpeed = (document.querySelector('.hero').dataset.transition && parseInt(document.querySelector('.hero').dataset.transition) > 0) ? parseInt(document.querySelector('.hero').dataset.transition) : 5000;
    let runningSlider = setInterval(runSlider, transitionSpeed);
    document.querySelectorAll('.slider-link').forEach(sliderLink => sliderLink.addEventListener('click', (e) => sliderLinkHandler(runningSlider, e)));

  });
  
}


// WEBPACK FOOTER //
// ./assets/js/modules/hero.js